export default "__VITE_ASSET__YLkL64mD__"